<template>
  <div v-if="percConciliado > 0">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          class="pl-4"
          :color="iconColor[statusIntegracaoErp.toString()]"
          small
          v-bind="attrs"
          v-on="on"
          >fa fa-exchange-alt</v-icon>
      </template>
      <span
        class="px-2 py-1 ma-0"
        style="
          border: solid 1px #999;
          border-radius: 5px;
          background-color: #fff;
        "
        >{{ iconTooltip[statusIntegracaoErp.toString()] }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import moment from "moment"
moment.locale("pt-BR")

export default {
  data() {
    return {
      iconColor: {
      "0": "primary",
      "1": "#B2B842",
      "2": "#9154CD",
      "3": "#32B88B",
      "-1": "#D0021B",
      "-2": "#FC9D0A"
      },
      iconTooltip: {
      "0": "Clique para integrar pagamento",
      "1": "Em processamento",
      "2": "Aguardando baixa contábil",
      "3": "Pagamento finalizado",
      "-1": "Falha total na integração",
      "-2": "Falha parcial na integração"
      }
    };
  },
  props: {
    percConciliado: Number,
    pagamento: Object
  },
  computed: {
    statusIntegracaoErp () {
      return this.pagamento.statusIntegracaoErp
    }
  },
  filters: {
    formatNullValue(val) {
      return val ? val : "-";
    },
  },
};
</script>
